import { render, staticRenderFns } from "./TopCart.vue?vue&type=template&id=71bf183c&scoped=true&"
import script from "./TopCart.vue?vue&type=script&lang=js&"
export * from "./TopCart.vue?vue&type=script&lang=js&"
import style0 from "./TopCart.vue?vue&type=style&index=0&id=71bf183c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bf183c",
  null
  
)

export default component.exports